import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DividasRegularizadasSerasa } from 'src/app/models/dividasRegularizadas/dividas-regularizadas-serasa';
import { FalhaServico } from 'src/app/models/falha-servico';
import { UtilLarguraTela } from 'src/app/utils/configuracoes/util-largura-tela';
import { MensagemRetorno } from 'src/app/utils/mensagens.retorno';
import { FotografiaService } from '../../fotografia/fotografia.service';
import { BlocoDividasRegularizadasSerasaService } from './bloco-dividas-regularizadas-serasa.service';

@Component({
  selector: 'app-bloco-dividas-regularizadas-serasa',
  templateUrl: './bloco-dividas-regularizadas-serasa.component.html',
  styleUrls: ['./bloco-dividas-regularizadas-serasa.component.scss']
})
export class BlocoDividasRegularizadasSerasaComponent implements OnInit {

  public larguraEhSuperiorMin: boolean;
  public listaServicoFalha: Array<string>;
  public falhaServico: FalhaServico;
  public dividasRegularizadasSerasa: DividasRegularizadasSerasa;
  public dividasRegularizadasSerasaConvem: DividasRegularizadasSerasa;
  public totalizadorDividasRegularizadasSerasa: number;
  private resultado: Promise<any>;
  @Input() recebeLoadingEvento: boolean;
  @Output() emiteLoadingEvento = new EventEmitter();

  constructor(private fotografiaService: FotografiaService, private blocoDividasRegularizadasSerasaService: BlocoDividasRegularizadasSerasaService) { 
    this.totalizadorDividasRegularizadasSerasa = 0;
    this.dividasRegularizadasSerasa = new DividasRegularizadasSerasa();
    this.dividasRegularizadasSerasaConvem = new DividasRegularizadasSerasa();
    this.falhaServico = new FalhaServico();
    this.listaServicoFalha = new Array();
  }

  ngOnInit(): void {

    this.larguraEhSuperiorMin = UtilLarguraTela.checarLarguraTela();
    this.obterDividasRegularizadasSerasa();

  }

  async obterDividasRegularizadasSerasa(){
    this.resultado = Promise.race[
      await this.consultarDividasRegularizadasRefin().catch,
      await this.consultarDividasRegularizadasPefin().catch,
      await this.consultarDividasRegularizadasConvem()
    ];

  }

  capturaErro(retornoErro: any, servico: string, bloco: string) {
    if(bloco === "CONVEM"){
      this.dividasRegularizadasSerasaConvem.falhaServico = retornoErro.error[0];
      this.dividasRegularizadasSerasaConvem.falhaServico.bloco = servico;
    }else{
      this.dividasRegularizadasSerasa.falhaServico = retornoErro.error[0];
      this.dividasRegularizadasSerasa.falhaServico.bloco = servico;
    }
    this.listaServicoFalha.push(servico);
    if(retornoErro.status !== 404){
      this.dividasRegularizadasSerasa.falhaServico.message = MensagemRetorno.mensagemRetornoStatus(retornoErro.status);
    }
    
  }

  async consultarDividasRegularizadasRefin(): Promise<any> {
    return this.blocoDividasRegularizadasSerasaService.consultarDividasRegularizadasRefin().then(res => {
      if(res == undefined){
        res = new DividasRegularizadasSerasa();
      }
      this.fotografiaService.concatenarFotografia(res.resultados, 'bloco-dividas-regularizadas-serasa');
      this.adicionarDividasRegularizadasSerasa(res.resultados);
      this.totalizadorDividasRegularizadasSerasa += res.resultados.length > 0 ? res.resultados.length : 0;
    }).catch((error)=>{
      this.capturaErro(error, 'bloco-dividas-regularizadas-serasa','');
      this.fotografiaService.concatenarFotografia(error, 'bloco-dividas-regularizadas-serasa');
      return Promise.resolve();
    })
    .finally(() => this.emiteLoadingEvento.emit("bloco-dividas-regularizadas-serasa-refin"));
  }

  async consultarDividasRegularizadasPefin(): Promise<any> {
    return this.blocoDividasRegularizadasSerasaService.consultarDividasRegularizadasPefin().then(res => {
      if(res == undefined){
        res = new DividasRegularizadasSerasa();
      }
      this.fotografiaService.concatenarFotografia(res.resultados, 'bloco-dividas-regularizadas-serasa');
      this.adicionarDividasRegularizadasSerasa(res.resultados);
      this.totalizadorDividasRegularizadasSerasa += res.resultados.length > 0 ? res.resultados.length : 0;
    }).catch((error)=>{
      this.capturaErro(error, 'bloco-dividas-regularizadas-serasa','');
      this.fotografiaService.concatenarFotografia(error, 'bloco-dividas-regularizadas-serasa');
      return Promise.resolve();
    })
    .finally(() => this.emiteLoadingEvento.emit("bloco-dividas-regularizadas-serasa-pefin"));

  }


  async consultarDividasRegularizadasConvem(): Promise<any> {
    this.dividasRegularizadasSerasaConvem.falhaServico = new FalhaServico();
    this.dividasRegularizadasSerasaConvem.falhaServico.message = MensagemRetorno.mensagemRetornoStatus('200');
    return this.blocoDividasRegularizadasSerasaService.consultarDividasRegularizadasConvem().then(res => {
      if(res == undefined){
        res = new DividasRegularizadasSerasa();
     }
     this.fotografiaService.concatenarFotografia(res.resultados, 'bloco-dividas-regularizadas-serasa');
      this.dividasRegularizadasSerasaConvem = res;
      this.totalizadorDividasRegularizadasSerasa += res.resultados.length > 0 ? res.resultados.length : 0;
    }).catch((error)=>{
      this.capturaErro(error, 'bloco-dividas-regularizadas-serasa','CONVEM');
      this.fotografiaService.concatenarFotografia(error, 'bloco-dividas-regularizadas-serasa');
      return Promise.resolve();
    })
    .finally(() => this.emiteLoadingEvento.emit("bloco-dividas-regularizadas-serasa-convem"));

  }

  private adicionarDividasRegularizadasSerasa(resultado: any) {
    this.dividasRegularizadasSerasa.falhaServico.message = resultado.length > 0 ? "" : MensagemRetorno.mensagemRetornoStatus('200');
    if (resultado !== undefined) {
      for (let index = 0; index < resultado.length; index++) {
        this.dividasRegularizadasSerasa.resultados.push(resultado[index]);
      }
    }

  }
}
